import { NewCard } from "@components/Cards/Templates/newCard";
import { TENANT } from "@types/tenant";

interface SecuritySettingsCardProps {
  tenantData: TENANT;
  updateTenantData: (data: TENANT) => void;
  loading: boolean;
}

export const SecuritySettingsCard: React.FC<SecuritySettingsCardProps> = ({
  tenantData,
  updateTenantData,
  loading,
}: any) => {
  return (
    <NewCard
      header="セキュリティ設定"
      bodyLabel=""
      loading={loading}
      bodyContents={
        <div>
          <h2 className="mb-6 label-light-blue-xl">ログイン方法設定</h2>
          <label className="flex items-center text-xl ml-5 mb-2">
            <input
              type="checkbox"
              className="mr-5 w-5 h-5 accent-blue-600"
              checked={tenantData?.local_auth}
              onChange={() =>
                updateTenantData("local_auth", !tenantData?.local_auth)
              }
            />
            ローカル認証
          </label>

          <div className="mt-5 divider" />

          <h2 className="mt-6 mb-6 label-light-blue-xl">電話帳参照制限</h2>
          <label className="flex items-center text-xl ml-5 mb-2">
            <input
              type="checkbox"
              className="mr-5 w-5 h-5 accent-blue-600"
              checked={tenantData?.require_passcode_for_phonebook}
              onChange={() =>
                updateTenantData(
                  "require_passcode_for_phonebook",
                  !tenantData?.require_passcode_for_phonebook,
                )
              }
            />
            電話帳参照時にパスコードの入力を求める
          </label>
        </div>
      }
    />
  );
};
